import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';

const Navbar: React.FC = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;
      setIsScrolled(scrollPosition > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const scrollToSection = (sectionId: string) => {
    setIsMenuOpen(false);
    const section = document.getElementById(sectionId);
    if (section) {
      const yOffset = -80; // Navbar height + padding
      const y = section.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: 'smooth' });
    }
  };

  const menuItems = [
    { id: 'our-story', label: 'historia' },
    { id: 'detalles-inicio', label: 'detalles' },
    { id: 'itinerary', label: 'itinerario' },
    { id: 'rsvp', label: 'rsvp' },
    { id: 'regalos', label: 'regalos' }
  ];

  return (
    <>
      <nav 
        className={`fixed top-0 left-0 right-0 z-50 px-4 py-3 transition-all duration-300 ${
          isScrolled ? 'bg-cream/90 backdrop-blur-md shadow-md' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto flex justify-between items-center">
          <div className="text-forest font-parisienne text-2xl tracking-wide">
            Emi & Carlos
          </div>
          
          {/* Desktop menu */}
          <div className="hidden md:flex space-x-8">
            {menuItems.map((item) => (
              <button
                key={item.id}
                onClick={() => scrollToSection(item.id)}
                className="text-forest hover:text-forest/70 capitalize text-lg tracking-wide font-parisienne relative group"
              >
                {item.label}
                <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-forest/30 group-hover:w-full transition-all duration-300"></span>
              </button>
            ))}
          </div>
          
          {/* Mobile menu button */}
          <button 
            className="md:hidden text-forest p-1 focus:outline-none"
            onClick={toggleMenu}
            aria-label="Open menu"
          >
            <Menu size={24} />
          </button>
        </div>
      </nav>
      
      {/* Mobile menu - completely hidden */}
      <div 
        className={`fixed inset-0 bg-cream/95 backdrop-blur-md z-50 flex flex-col justify-center items-center transition-all duration-500 transform ${
          isMenuOpen ? 'translate-x-0' : 'translate-x-full'
        }`}
      >
        <button 
          className="absolute top-4 right-4 text-forest"
          onClick={toggleMenu}
          aria-label="Close menu"
        >
          <X size={24} />
        </button>
        
        <div className="flex flex-col items-center space-y-6">
          {menuItems.map((item) => (
            <button
              key={item.id}
              onClick={() => scrollToSection(item.id)}
              className="text-forest hover:text-forest/70 capitalize text-2xl tracking-wide font-parisienne relative group"
            >
              {item.label}
              <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-forest/30 group-hover:w-full transition-all duration-300"></span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default Navbar;
